export default {
	methods: {
		viewFile(path) {
			window.open(path);
		},
		downloadFile(path, filename, uniqueId) {
			// window.location = path;
			this.$store.dispatch("downloadsStore/download", {
				path: path,
				filename: filename,
				uniqueId: uniqueId,
			});
		},
		streamFile(path, filename, uniqueId) {
			this.$store.dispatch("downloadsStore/download", {
				stream: true,
				path: path,
				filename: filename,
				uniqueId: uniqueId,
			});
		},
	},
};
